import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import {Box, Divider, Grid, LinearProgress} from '@mui/material';
import AgyleMenuIcon from '../agyleMenu/agyleMenuIcon';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import {useSelector} from 'react-redux';
import {agyleHeaderContext, agyleHeaderLoading} from '../../../store/reducers/globals';
import HeaderLinks from './headerLinks';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import ActionPanelButton from '../../actionPanel/actionPanelButton';

const useStyles = makeStyles(theme => ({
    row: {
        // backgroundColor: theme.palette.mode === "light" ? "#f0f0f0" : "#333333",
        backgroundColor: theme.palette.background.paperDarker,
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        // alignItems: "center",
        paddingTop: '0.5em',
        paddingBottom: '0.5em',
    },
    darkBackground: {
        background: theme.palette.background.default,
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        backgroundColor: theme.palette.mode === 'light' ? '#eff1f3' : '#333333',
    },
    borderBottom: {
        borderBottom: `2px solid ${theme.palette.mode === 'light' ? '#939393' : '#434343'}`,
    },
    progress: {
        width: '100%',
        height: 5,
    },
    agyleMenu: {
        marginLeft: 5,
    },
    background: {
        backgroundColor: theme.palette.background.paperDarker,
    },
}));

const AgyleHeader = (props) => {
    const classes = useStyles();
    const history = useHistory();

    // Outside context
    const ctx = useSelector(agyleHeaderContext);
    const headerLoading = useSelector(agyleHeaderLoading);

    const handleBack = () => {
        if (props.onBack) props.onBack();
        else history.goBack();
    };

    const renderContext = () => {
        return (
            <>
                {ctx && ctx}
                {(!ctx || props.forceChildren) && props.children}
            </>
        );
    };

    return (
        <>
            <div id="agyle-header" className={clsx(classes.divRow, classes.background, props.rootContainerStyle)}>
                <Grid
                    container
                    direction="row"
                    id="patient-header-row"
                    alignItems="center"
                    className={clsx(classes.row, props.borderBottom && classes.borderBottom, props.darkBackground && classes.darkBackground, props.rootStyle)}
                >
                    {!props.disableLogo &&
                        <div className={classes.agyleMenu}>
                            <AgyleMenuIcon/>
                        </div>
                    }

                    {!props.disableBack &&
                        <Tooltip title={props.backTooltip}>
                            <IconButton
                                disableRipple
                                onClick={handleBack}
                            >
                                <ArrowBackIcon/>
                            </IconButton>
                        </Tooltip>
                    }

                    {renderContext()}
                </Grid>

                {props.displayLink &&
                    <div style={{float: 'right'}}>
                        <HeaderLinks/>
                    </div>
                }

                {props.showActionPanel &&
                    <ActionPanelButton/>
                }

                {props.divider && <Divider/>}
            </div>

            {!props.noProgress &&
                <Box className={classes.progress}>
                    {(props.loading || headerLoading) && <LinearProgress/>}
                </Box>
            }
        </>
    );
};

export default AgyleHeader;

AgyleHeader.propTypes = {
    divider: PropTypes.bool,
    disableBack: PropTypes.bool,
    disableLogo: PropTypes.bool,
    onBack: PropTypes.func,
    forceChildren: PropTypes.bool,
    displayLink: PropTypes.bool,
    loading: PropTypes.bool,
    rootStyle: PropTypes.any,
    darkBackground: PropTypes.bool,
    showActionPanel: PropTypes.bool,
    rootContainerStyle: PropTypes.any,
    backTooltip: PropTypes.string,
};

AgyleHeader.defaultProps = {
    divider: false,
    disableBack: false,
    disableLogo: false,
    forceChildren: false,
    onBack: null,
    displayLink: false,
    loading: false,
    darkBackground: false,
    showActionPanel: false,
    backTooltip: 'Back',
};